import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../../common/buttons/onboarding/OnboardingButton';
import Message from '../../../common/message/Message';
import Heading from '../../../common/heading/Heading';
import socialProviderName from '../../helpers/socialProviderName';
import {
	ONBOARDING_LINK_SUCCESS_TITLE,
	ONBOARDING_LINK_SUCCESS_SUBTITLE,
	ONBOARDING_LINK_SUCCESS_CTA,
} from '../../../../constants/Copy';

const LinkSuccess = ({ onClick, loading, provider }) => (
	<>
		<Heading>
			<Message
				message={ONBOARDING_LINK_SUCCESS_TITLE}
				values={{ provider: socialProviderName(provider) }}
			/>
		</Heading>
		<p className="onboarding__text">{ONBOARDING_LINK_SUCCESS_SUBTITLE}</p>
		<p className="onboarding__text">
			<Button onClick={onClick} loading={loading}>
				{ONBOARDING_LINK_SUCCESS_CTA}
			</Button>
		</p>
	</>
);

LinkSuccess.propTypes = {
	onClick: PropTypes.func.isRequired,
	loading: PropTypes.bool.isRequired,
};

export default LinkSuccess;
